import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore, createTransform } from 'redux-persist';
import agentsReducer from "./slices/agents.slice";
import sessionReducer from "./slices/session.slice";
import liveCallsReducer from "./slices/liveCalls.slice";
import accountsReducer from './slices/accounts.slice';
import appConfigReducer from "./slices/api.slice";
import integrationsReducer, { INTEGRATIONS_CACHE_TTL_MS } from './slices/integrations.slice';
import appsReducer from './slices/apps.slice';
import callCenterReducer from './slices/callcenter.slice';

// TTL transform: drop stale lookups older than 2 days on rehydrate
const integrationsTTLTransform = createTransform(
  (inboundState: any) => inboundState,
  (outboundState: any) => {
    try {
      if (!outboundState?.items) return outboundState;
      const now = Date.now();
      const items = outboundState.items.map((integration: any) => {
        const lookups = Array.isArray(integration.lookups)
          ? integration.lookups.filter((l: any) => {
              const ts = typeof l?._cachedAt === 'number' ? l._cachedAt : 0;
              const keep = ts && now - ts <= INTEGRATIONS_CACHE_TTL_MS;
              if (!keep) console.log(`[TTL] Dropping stale lookup`, l);
              return keep;
            })
          : [];
        return { ...integration, lookups };
      });
      console.log(`[TTL] After transform`, items);
      return { ...outboundState, items };
    } catch (e) {
      console.error(`[TTL] Error in transform`, e);
      return outboundState;
    }
  },
  { whitelist: ['integrations'] }
);

const rootReducer = combineReducers({
  agents: agentsReducer,
  session: sessionReducer,
  liveCalls: liveCallsReducer,
  accounts: accountsReducer,
  appConfig: appConfigReducer,
  integrations: integrationsReducer,
  apps: appsReducer,
  callCenter: callCenterReducer,
});

const persistConfig: any = {
  key: 'root',
  storage,
  whitelist: ['integrations'],
  transforms: [integrationsTTLTransform],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
